import React from 'react';
import { AlertCircle, Inbox, RefreshCw } from 'lucide-react';

export const AdminSkeleton = ({ rows = 6, label = 'Veriler yükleniyor' }) => (
  <div className="admin-card admin-skeleton-wrap" role="status" aria-label={label}>
    <span className="sr-only">{label}</span>
    {Array.from({ length: rows }, (_, index) => (
      <div className="admin-skeleton-row" key={index}>
        <span />
        <span />
        <span />
        <span />
      </div>
    ))}
  </div>
);

export const AdminError = ({ message, onRetry }) => (
  <div className="admin-card admin-state" role="alert">
    <AlertCircle size={28} className="text-red-400" aria-hidden="true" />
    <h2>Veriler alınamadı</h2>
    <p>{message || 'Beklenmeyen bir hata oluştu.'}</p>
    {onRetry && (
      <button type="button" className="admin-btn-secondary" onClick={onRetry}>
        <RefreshCw size={14} aria-hidden="true" /> Tekrar dene
      </button>
    )}
  </div>
);

export const AdminEmpty = ({
  title = 'Henüz kayıt yok',
  description = 'Bu filtreye uygun bir kayıt bulunamadı.',
  action,
}) => (
  <div className="admin-state">
    <Inbox size={28} className="text-slate-500" aria-hidden="true" />
    <h2>{title}</h2>
    <p>{description}</p>
    {action}
  </div>
);

